import { render, staticRenderFns } from "./UnsubscribedUser.vue?vue&type=template&id=709a2dda&scoped=true&"
import script from "./UnsubscribedUser.vue?vue&type=script&lang=js&"
export * from "./UnsubscribedUser.vue?vue&type=script&lang=js&"
import style0 from "./UnsubscribedUser.vue?vue&type=style&index=0&id=709a2dda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709a2dda",
  null
  
)

export default component.exports